import { useState, createContext } from 'react'
import { MenuContextType } from '../types/andTypes'

export const MenuContext = createContext({} as MenuContextType)

// eslint-disable-next-line
export const MenuProvider = ({ children }: any) => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false)

  return (
    <MenuContext.Provider
      value={{
        menuOpen,
        setMenuOpen
      }}
    >
      {children}
    </MenuContext.Provider>
  )
}
